import React, { useMemo } from 'react';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import FactoringRequestsSent from 'pages/Finance/Components/Financing/Factoring/components/Sent';
import PendingAccounts from 'pages/PruffConnect/Factoring/components/PendingAccounts';
import BusinessInvoices from 'pages/BusinessProfile/SII/Components/BusinessInvoices';
import { RootState } from 'services/redux/store';
import { useSelector } from 'react-redux';
import AutoEnrollment from 'pages/PruffConnect/AutoEnrollment';
import CreditLineStatus from '../Common/CreditLineStatus';

const Factoring = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const isAutoEnrolled = useMemo(() => auth.user?.autoEnrrolled, [auth.user]);
  const getAvailableTabs = () => {
    return [
      {
        label: 'Línea de Crédito',
        component: <CreditLineStatus productId="factoring" />,
        index: 0,
      },
      {
        label: 'Mis Facturas',
        component: isAutoEnrolled ? <BusinessInvoices /> : <AutoEnrollment />,
        index: 1,
      },
      {
        label: 'Facturas Enviadas',
        component: <FactoringRequestsSent />,
        index: 2,
      },
      {
        label: 'Cuentas Pendientes',
        component: <PendingAccounts />,
        index: 3,
      },
    ];
  };

  const tabs = getAvailableTabs();

  return (
    <div>
      <EnhancedTab title="Factoring" startValue={0} tabs={tabs} />
    </div>
  );
};

export default Factoring;
